import { Camera3D, Scene3D, WebGLRenderer3D } from 'feng3d-three';
import { AnaglyphEffect } from '../thirdparty/three/imports';

export class AnaglyphEffect3D
{
    _anaglyphEffect: AnaglyphEffect;

    constructor(renderer: WebGLRenderer3D, width?: number, height?: number)
    {
        this._anaglyphEffect = new AnaglyphEffect(renderer._webGLRenderer, width, height);
    }

    setSize(width: number, height: number)
    {
        this._anaglyphEffect.setSize(width, height);
    }

    render(scene: Scene3D, camera: Camera3D)
    {
        // 修复渲染前更新摄像机矩阵数据
        // @see https://github.com/mrdoob/three.js/blob/r149/src/renderers/WebGLRenderer.js#L963
        camera.updateMatrixWorld();
        //
        this._anaglyphEffect.render(scene._scene, camera._camera);
    }
}
